<template>
    <div class="global-quicksearch-suggestions">
        <p class="typo-light">{{ $t('search.labels.suggestions') }}</p>
        <ul>
            <li class="global-quicksearch-suggestions__suggestion" :class="selected(key)" v-for="(item, key) in suggestions" :key="item"
                @click="select(item)"
                @mouseover="hover(item)"
                v-html="highlightKeyword(item)">
            </li>
        </ul>

    </div>
</template>

<script>
export default {
    name: "global-quicksearch-suggestions",
    props: ['suggestions', 'keyword'],
    data() {
        return {
            selectedKey: -1
        }
    },
    watch: {
        suggestions() {
            this.selectedKey = -1;
        }
    },
    methods: {
        select(item) {
            this.$emit('selected', {detail: item})
        },
        hover(item) {
            this.selectedKey = -1;
        },
        selected(key) {
            return key === this.selectedKey ? 'global-quicksearch-suggestions__suggestion--selected' : '';
        },
        keystroke(e) {
            if (e.isComposing || event.keyCode === 229) {
                return
            }

            if (e.key === 'ArrowUp') {
                this.decreaseSelected()
            }

            if (e.key === 'ArrowDown') {
                this.increaseSelected()
            }

            if (e.key === 'Enter') {
                if (this.selectedKey !== -1) {
                    this.$emit('selected', {detail: this.suggestions[this.selectedKey]})
                    this.selectedKey = -1
                }
            }
        },
        increaseSelected() {
            this.selectedKey = (this.selectedKey + 1) % this.suggestions.length
        },
        decreaseSelected() {
            this.selectedKey = (this.selectedKey - 1) % this.suggestions.length
        },
        highlightKeyword(item) {
            if (this.keyword && this.keyword.length > 3) {
                const highlightRegex = new RegExp(this.keyword, 'gi')
                const result = highlightRegex.exec(item)

                if (result) {
                    return item.substr(0, result.index) + '<b>' + item.substr(result.index, this.keyword.length) + '</b>' + item.substr(result.index + this.keyword.length, item.length)
                }
            }

            return item
        }
    },
    mounted() {
        window.addEventListener('keyup', this.keystroke)
    }
}
</script>
